import { render, staticRenderFns } from "./peoples.vue?vue&type=template&id=30599dc4&"
import script from "./peoples.vue?vue&type=script&lang=js&"
export * from "./peoples.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('30599dc4')) {
      api.createRecord('30599dc4', component.options)
    } else {
      api.reload('30599dc4', component.options)
    }
    module.hot.accept("./peoples.vue?vue&type=template&id=30599dc4&", function () {
      api.rerender('30599dc4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/icons/svg/peoples.vue"
export default component.exports